import React from "react"
import { connect } from "react-redux"
import { Cell } from "fixed-data-table-2"

import Icon from "app/static/frontend/components/Icon"
import { getBulkUploadLinkForResourceTable } from "app/static/frontend/custom-contacts-upload/action-creators"

export class BulkUploadCell extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDownloading: false,
        }
    }

    handleOnClick = async () => {
        this.setState((state) => ({ ...state, isDownloading: true }))
        try {
            await this.props.getBulkUploadLinkForResourceTable(this.props.datum)
        } catch (exception) {
            // pass here, error handling in action creator
        }
        this.setState((state) => ({ ...state, isDownloading: false }))
    }

    render = () => {
        if (this.state.isDownloading) {
            return (
                <Cell {...this.props}>
                    {"Preparing Link..."} <Icon name="fa-spinner fa-spin" />
                </Cell>
            )
        }
        return (
            <div role="button" onClick={this.handleOnClick} onKeyUp={this.handleOnClick} tabIndex={0}>
                <Cell {...this.props}>{this.props.datum.get("name")}</Cell>
            </div>
        )
    }
}

export default connect(null, { getBulkUploadLinkForResourceTable })(BulkUploadCell)
